import { render, staticRenderFns } from "./LoaderMenuContentColumns.vue?vue&type=template&id=4d257d60&"
import script from "./LoaderMenuContentColumns.vue?vue&type=script&lang=js&"
export * from "./LoaderMenuContentColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports